import React from "react";
import CustomButton from "../Button/CustomButton";
import { Box, Modal, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
const DeleteModal = ({ open, handleDelete, modalID, onClose }) => {
  return (
    <>
      <Modal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={onClose}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            outline: "none",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "20px",
          }}
        >
          <Typography variant="h6" component="h2">
            Are you sure you want to Delete?
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <HelpOutlineIcon
              sx={{
                width: "75px",
                height: "100px",
                color: "#31AEF4",
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 5,
              mt: 2,
            }}
          >
            <CustomButton onClick={() => handleDelete(modalID)}>
              Yes
            </CustomButton>
            <CustomButton onClick={onClose}>No</CustomButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteModal;
